export const NEARBY_ROUTE_DEFAULTS = Object.freeze({
  MAX_SEARCH_LENGTH: 200,
  MAX_SELECTIONS: 6,
  PAGE: 1,
  PAGE_SIZE: 20,
  SORT_DIRECTION: "asc",
  SORT_FIELD: "name",
});

export const NEARBY_ROUTE_PAGE_SIZES = Object.freeze([10, 20, 50, 100]);

const RTL_LANGUAGE_CODES = new Set(["ar", "fa", "he", "ur"]);

export const getTextDirection = languageCode =>
  RTL_LANGUAGE_CODES.has(`${languageCode || ""}`.toLowerCase().split("-")[0]) ? "rtl" : "ltr";

export const moveSelectedRoute = (routeIds, sourceIndex, destinationIndex) => {
  if (
    sourceIndex === destinationIndex ||
    sourceIndex < 0 ||
    destinationIndex < 0 ||
    sourceIndex >= routeIds.length ||
    destinationIndex >= routeIds.length
  ) {
    return routeIds;
  }
  const reorderedIds = [...routeIds];
  const [movedId] = reorderedIds.splice(sourceIndex, 1);
  reorderedIds.splice(destinationIndex, 0, movedId);
  return reorderedIds;
};

export const appendSelectedRoute = (routeIds, routeId, maximumSelections) => {
  if (routeIds.includes(routeId) || routeIds.length >= maximumSelections) return routeIds;
  return [...routeIds, routeId];
};

export const updateVisibleRouteSelections = (selectedRouteIds, visibleRouteIds, selected, maximumSelections) => {
  if (!selected) {
    const visibleRouteIdSet = new Set(visibleRouteIds);
    return selectedRouteIds.filter(routeId => !visibleRouteIdSet.has(routeId));
  }
  return visibleRouteIds.reduce(
    (routeIds, routeId) => appendSelectedRoute(routeIds, routeId, maximumSelections),
    selectedRouteIds,
  );
};

export const buildAssociations = routeIds =>
  routeIds.map((nearbyRouteId, index) => ({ nearbyRouteId, displayOrder: index + 1 }));

export const haveSameRouteOrder = (leftIds, rightIds) =>
  leftIds.length === rightIds.length && leftIds.every((routeId, index) => routeId === rightIds[index]);

export const buildOptionLabelLookup = options =>
  (options || []).reduce((labels, option) => {
    const value = option.id || option.value;
    if (!value) return labels;
    return { ...labels, [value]: option.name || option.label || value };
  }, {});

export const getMarketAssignmentLabels = (marketAssignments, marketLabelsById = {}) =>
  [...new Set((marketAssignments || []).map(assignment => assignment.marketId).filter(Boolean))].map(
    marketId => marketLabelsById[marketId] || marketId,
  );

export const getSubmarketAssignmentLabels = (marketAssignments, submarketLabelsById = {}) =>
  [...new Set((marketAssignments || []).flatMap(assignment => assignment.submarketIds || []).filter(Boolean))].map(
    submarketId => submarketLabelsById[submarketId] || submarketId,
  );
